import {makeStyles} from '@material-ui/core/styles'
import {reExportedColors, Text} from '../../components/1elements'
import GeneralGuidelinesTable from '../../components/3modules/bulkImportRules/GeneralGuidelinesTable'
import RequiredColumnsTable from '../../components/3modules/bulkImportRules/RequiredColumnsTable'
import OptionalColumnsTable from '../../components/3modules/bulkImportRules/OptionalColumnsTable'
import CommonErrorsTable from '../../components/3modules/bulkImportRules/CommonErrorsTable'

const BulkImportFormatTemplate = ({requiredColumns, optionalColumns, header, description, beforeYouBegin, columnReferencePath}) => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div className={classes.innerDiv}>
                <div className={classes.header}>
                    <Text type={'bulkImportRuleHeader1'}>{header}</Text>
                    <Text type={'bulkImportRuleBody'}>
                        {description}
                    </Text>
                </div>

                <div className={classes.blockSpacer}>
                    <Text type={'bulkImportRuleHeader2'}>Before you begin,</Text>
                    <ul>
                        {beforeYouBegin}
                    </ul>
                </div>

                <div className={classes.blockSpacer} id={'formatGuidelines'}>
                    <Text type={'bulkImportRuleHeader2'}>Format Guidelines</Text>
                    <GeneralGuidelinesTable />
                </div>

                <div className={classes.blockSpacer} id={'columnReference'}>
                    <Text type={'bulkImportRuleHeader3'}>Column Reference</Text>
                    <RequiredColumnsTable requiredColumnList={requiredColumns} />
                    <div className={classes.subBlockSpacer}>
                        <OptionalColumnsTable optionalColumnList={optionalColumns} />
                    </div>
                </div>

                <div className={classes.blockSpacer} id={'commonErrors'}>
                    <Text type={'bulkImportRuleHeader2'}>Resolve Common Errors</Text>
                    <Text type={'bulkImportRuleBody'}>Errors you may encounter when you upload your CSV file and start the import process</Text>
                    <CommonErrorsTable columnReferencePath={columnReferencePath} />
                </div>
            </div>
        </div>
    )
}

export default BulkImportFormatTemplate

const useStyles = makeStyles({
    root: {
        width: "90vw",
        margin: "25px 0 25px 100px",
        borderRadius:" 0px 6px 6px 6px",
        padding: "15px",
        boxShadow: "0px 0px 3px #00000029",
        position: 'relative'
    },
    header: {
        margin: '10px 0'
    },
    blockSpacer: {
        margin: '30px 0'
    },
    subBlockSpacer: {
        margin: '15px 0'
    },
    goBackButtonfull: {
        borderRadius: '4px 0px 0px 4px',
        backgroundColor: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        transition: 'all 0.2s ease-in-out',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 28,
        height: 35,
        boxShadow: '0px 0px 3px #00000029',
        marginLeft: "20px",
        cursor: "pointer",
        position: 'absolute',
        right: '0'
    },
    innerDiv: {
    }
})